var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"global__messages"},[_c('transition-group',{attrs:{"name":"fade","tag":"ul"}},_vm._l((_vm.getMessages),function(message,index){return _c('li',{key:message['id'] + index,staticClass:"global__message--bg",class:message['type']},[_vm._v("\n      "+_vm._s(message['message'])+"\n    ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }